export const BASE_URL = process.env.REACT_APP_API_URL || "http://127.0.0.1:4000/api/v1"
export const PROPERTIES_URL = `${BASE_URL}/properties`;
export const ASSETS_URL = process.env.REACT_APP_LARAVEL_ASSETS_URL || "http://127.0.0.1:8000/storage";

//properties
export const GET_PROPERTY_BY_SLUG = `${PROPERTIES_URL}/`;
export const SEARCH_PROPERTIES = `${PROPERTIES_URL}/search`;
export const SEARCH_PROPERTIES_WITH_FILTERS = `${PROPERTIES_URL}/search-with-filters`;
export const GET_PROPERTY_CATEGORIES = `${PROPERTIES_URL}/categories`;
export const SAVE_PROPERTY = `${PROPERTIES_URL}/saved-properties/save`;
export const SAVE_FAVORITES = `${PROPERTIES_URL}/property-favorites/save-many`;
export const SAVE_FAVORITE = `${PROPERTIES_URL}/property-favorites/save-one`;
export const GET_SAVED_PROPERTIES = `${PROPERTIES_URL}/saved-properties/get-properties`;
export const SUBMIT_VIEWING_REQUEST = `${PROPERTIES_URL}/property-viewings/create`;// Submit viewing request



export const CONTACT_AN_AGENT = `${BASE_URL}/agent-inquiries/create`;// Contact an agent

export const CREATE_ACCOUNT = `${BASE_URL}/users/register`;// Create account
export const LOGIN = `${BASE_URL}/auth/login`;// Login
export const FORGOT_PASSWORD = `${BASE_URL}/auth/forgot-password`;// Forgot password
export const RESET_PASSWORD = `${BASE_URL}/auth/reset-password`;

export const GET_ALL_SUBURBS = `${BASE_URL}/locations/suburbs`;// Get all suburbs
export const GET_SUBURB_LIST = `${BASE_URL}/locations/suburbs/list`;// Get suburbs

export const GET_COUNTIES = `${BASE_URL}/locations/counties`;// Get counties
export const GET_COUNTY_CITIES = `${BASE_URL}/locations/cities`;// Get cities
export const GET_CITY_SUBURBS = `${BASE_URL}/locations/suburbs/by-city`;// Get city suburbs
export const GET_COUNTY_SUBURBS = `${BASE_URL}/locations/suburbs/by-county`;// Get cities


export const GET_AGENT_LIST = `${BASE_URL}/agents`;// Get agents

export const GET_CLIENT_PROFILE = `${BASE_URL}/clients/me`;// Get client profile
export const SAVE_CLIENT_PROFILE = `${BASE_URL}/clients/update`;// Get agent profile

export const GET_AGENT_PROFILE = `${BASE_URL}/agents/profile`;// Get agent profile
export const SAVE_AGENT_PROFILE = `${BASE_URL}/agents/save`;// Get agent profile
export const SAVE_AGENT_RATING = `${BASE_URL}/agents/ratings/save`;// Save agent rating
export const SAVE_AGENT_REFERENCE = `${BASE_URL}/agent-references/create`;// Save agent reference
export const DELETE_AGENT_REFERENCE = `${BASE_URL}/agent-references/delete`;// delete agent reference
export const UPDATE_AGENT_REFERENCE = `${BASE_URL}/agent-references/update`;// update agent reference


export const UPDATE_USER = `${BASE_URL}/users/update`;// Get agent profile


export const MATCH_TO_PROVIDERS = `${BASE_URL}/mortgage/providers/match`;// Match engine

export const GET_CAREERS = `${BASE_URL}/careers/active`;// Active Careers
export const APPLY_JOB = `${BASE_URL}/job-applications/create`;// Apply job

export const GET_COMPANIES = `${BASE_URL}/companies`;// update agent reference
export const SAVE_MEMBERSHIP = `${BASE_URL}/company-memberships/create`;// update agent reference
export const DELETE_MEMBERSHIP = `${BASE_URL}/company-memberships/delete`;// delete agent reference
export const AGENTS_PORTAL = process.env.REACT_APP_AGENTS_URL || `http://localhost:5173`;

//blogs
export const GET_BLOGS = `${BASE_URL}/blogs/published`;// Get blogs
export const GET_BLOG_BY_SLUG = `${BASE_URL}/blogs/slug`;// Get blog by slug

export const GET_NEWS = `${BASE_URL}/news/published`;// Get news
export const GET_NEWS_BY_SLUG = `${BASE_URL}/news/slug`;// Get news by slug

//testimonials
export const GET_TESTIMONIALS = `${BASE_URL}/testimonials`;// Get testimonials


